import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledBulkActionBarContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  margin: 2px 0;
  padding: 8px;
  background-color: ${colorsPalettes.carbon[0]};
`;

export const StyledSelectedText = styled.span`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[400])};
  min-width: 70px;
  text-transform: capitalize;
`;

export const StyledSeparator = styled.div`
  height: 24px;
  width: 1px;
  background-color: ${colorsPalettes.carbon[100]};
`;
